import React from "react";
import { FiActivity, FiSettings } from "react-icons/fi";
import { cn } from "../../../utils/cn";

const modes = [
  { id: "administracion", label: "Administración", Icon: FiSettings },
  { id: "monitoreo", label: "Monitoreo", Icon: FiActivity },
];

const KioskModeToggle = ({ activeMode, onChange }) => (
  <div className="flex flex-wrap gap-2" aria-label="Sección de KIOSK">
    {modes.map(({ id, label, Icon }) => (
      <button
        key={id}
        type="button"
        aria-pressed={activeMode === id}
        onClick={() => onChange(id)}
        className={cn(
          "flex items-center gap-2 px-4 py-2.5 border text-sm font-semibold rounded-xl shadow-sm transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007FB4]/40",
          activeMode === id
            ? "bg-[#1D1F3F] border-[#1D1F3F] text-white"
            : "bg-white border-slate-200 text-slate-700 hover:bg-slate-50"
        )}
      >
        <Icon className="w-4 h-4" />
        {label}
      </button>
    ))}
  </div>
);

export default KioskModeToggle;
